import { createStore } from 'zustand';
import { TermsOfConsentStore, TermsOfConsentStoreFunction } from './TermsOfConsentContext';

export const createTermsOfConsentStore = () => {
    return createStore<TermsOfConsentStore & TermsOfConsentStoreFunction>()(set => ({
        showTermsOfUseWithCheckBox: false,
        isConsentTermsOfUseChecked: false,
        showConsentTermsOfUseNotification: false,
        setShowTermsOfUseWithCheckBox: (showTermsOfUseWithCheckBox: boolean) =>
            set(() => ({ showTermsOfUseWithCheckBox })),
        setIsConsentTermsOfUseChecked: (isConsentTermsOfUseChecked: boolean) =>
            set(() => ({ isConsentTermsOfUseChecked })),
        setShowConsentTermsOfUseNotification: (showConsentTermsOfUseNotification: boolean) =>
            set(() => ({ showConsentTermsOfUseNotification })),
    }));
};
